import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { Spinner } from './components'
import { Route, Switch, Redirect } from 'react-router-dom'
import {
  ResidentsView,
  DocumentsView,
  RentIntentionView,
  FinancialView,
  OverviewView,
  SentView,
  StartView,
  ContractView,
  ResendView,
} from './views'
import * as routeService from './services/routeService'
import { getAllData } from './actions/FlowAction'
import { userSchema } from './utils/user'
import PropertyNotFoundView from './views/PropertyNotFoundView'

export const routes = match => (
  <Switch>
    <Route path={`${match.url}/bewoners`} component={ResidentsView} />
    <Route path={`${match.url}/huurintentie`} component={RentIntentionView} />
    <Route path={`${match.url}/huurcontract`} component={ContractView} />
    <Route path={`${match.url}/inkomsten`} component={FinancialView} />
    <Route path={`${match.url}/documenten`} component={DocumentsView} />
    <Route path={`${match.url}/overzicht`} component={OverviewView} />
    <Route path={`${match.url}/bedankt`} component={SentView} />
    <Route path={`${match.url}/opnieuw`} component={ResendView} />
    <Route path={`${match.url}/start`} component={StartView} />
    <Route path={`${match.url}/profiel`} render={() => <Redirect to="/profiel" />} />
  </Switch>
)

class AppProperty extends Component {
  componentDidMount = async () => {
    const params = this.props.match.params
    if (!params.id) {
      return routeService.goTo404()
    }
    try {
      const { user } = this.props

      const isValid = userSchema.isValidSync(user)
      if (!isValid) {
        routeService.goToPageInternal('/register', { replace: true })
      } else {
        await this.props.getAllData(params.id, this.props.user)
      }
    } catch (err) {
      routeService.goTo404()
    }
  }

  componentDidUpdate = oldProps => {
    if (this.props.step !== oldProps.step || this.props.completedAt !== oldProps.completedAt) {
      this.goToCorrectRouteForPhase()
    }
  }

  goToCorrectRouteForPhase = () => {
    let { step, completedAt, finishedStep, property } = this.props
    const { zip } = property
    routeService.redirectByPhase(step, completedAt, finishedStep, zip)
  }

  render() {
    const { match, propertySuccess } = this.props

    if (this.props.propertyFail) {
      return <PropertyNotFoundView />
    }

    return (
      <Fragment>
        {!propertySuccess && <Spinner size="large" />}
        {propertySuccess && routes(match)}
      </Fragment>
    )
  }
}

AppProperty.propTypes = {
  match: PropTypes.object,
  getAllData: PropTypes.func,
  user: PropTypes.any,
  propertySuccess: PropTypes.bool,
  propertyFail: PropTypes.bool,
  property: PropTypes.object,
  finishedStep: PropTypes.object,
  step: PropTypes.any,
  broker: PropTypes.object,
  completedAt: PropTypes.any,
}

const mapStateToProps = ({ FlowReducer, AuthReducer }) => {
  const {
    propertySuccess,
    propertyFail,
    property,
    step,
    completedAt,
    isFirstApplication,
    broker,
    application: { finishedStep },
  } = FlowReducer
  const { user } = AuthReducer
  return {
    propertySuccess,
    propertyFail,
    property,
    user,
    step,
    completedAt,
    isFirstApplication,
    broker,
    finishedStep,
  }
}
const mapDispatchToProps = dispatch => ({
  getAllData: (propertyId, user) => dispatch(getAllData(propertyId, user)),
  resetStores: () => dispatch({ type: 'RESET' }),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AppProperty)



// WEBPACK FOOTER //
// ./src/AppProperty.js